import { useCallback } from "react";
import { OBJECT_TYPES, CORRIDOR_WALL_THICKNESS_M } from "../configuratorConstants";
import { getObjectById } from "../state/projectReducer";
import { useTranslation } from 'react-i18next';

export const useContextMenuHandler = (state, dispatch, uiState, actions, screenToWorld) => {
  const { setContextMenu } = actions;
  const { selectedObjectId, projectObjects, currentFloorId } = state;
  const { closeContextMenu } = uiState;
  const { t } = useTranslation();

  const handleContextMenu = useCallback(
    (event, objectIdFromClick, objectTypeFromClick, contextData = {}) => {
      event.preventDefault();
      event.stopPropagation();

      let options = [];
      const clickedObjectId = objectIdFromClick || selectedObjectId;
      const clickedObject = objectIdFromClick ? 
                            { id: objectIdFromClick, type: objectTypeFromClick, ...contextData } : 
                            getObjectById(clickedObjectId, currentFloorId, projectObjects);

      if (clickedObject) {
         if (clickedObject.type === OBJECT_TYPES.MODULE) {
            options.push({
              label: t('contextMenu.rotateModule'),
              onClick: () => dispatch({ type: 'ROTATE_SELECTED_MODULE' }),
            });
         }
         if (clickedObject.type === OBJECT_TYPES.WALL_SEGMENT) {
            const { isInternal, currentThickness, moduleId, segmentKeyInModule } = clickedObject; 
            
            if (isInternal && moduleId && segmentKeyInModule) {
                options.push({ isSeparator: true });
                const isCorridor = currentThickness === CORRIDOR_WALL_THICKNESS_M;
                options.push({
                    label: isCorridor ? t('contextMenu.makeWallStandard') : t('contextMenu.makeWallCorridor'),
                    onClick: () => dispatch({ 
                        type: 'TOGGLE_WALL_THICKNESS', 
                        payload: { moduleId, segmentKeyInModule }
                    }),
                });
            }
         }
         if (clickedObject.type === OBJECT_TYPES.DOCKING_JOINT && clickedObject.id) {
            const joint = getObjectById(clickedObject.id, currentFloorId, projectObjects);
            if (joint && joint.displayMode !== 'passage') {
                options.push({ isSeparator: true });
                options.push({
                    label: t('contextMenu.createPassage'),
                    onClick: () => dispatch({ type: 'SET_DOCKING_JOINT_DISPLAY_MODE', payload: { jointId: joint.id, mode: 'passage' } }),
                });
            } else if (joint && joint.displayMode === 'passage') {
                options.push({ isSeparator: true });
                options.push({
                    label: t('contextMenu.restoreDoubleWall'),
                    onClick: () => dispatch({ type: 'SET_DOCKING_JOINT_DISPLAY_MODE', payload: { jointId: joint.id, mode: 'double' } }),
                });
                 options.push({
                    label: t('contextMenu.restoreSingleWall'),
                    onClick: () => dispatch({ type: 'SET_DOCKING_JOINT_DISPLAY_MODE', payload: { jointId: joint.id, mode: 'single' } }),
                });
            }
         }
      }

      if (options.length > 0) {
        if (clickedObjectId && selectedObjectId !== clickedObjectId) {
          dispatch({ type: 'SET_SELECTED_OBJECT_ID', payload: clickedObjectId });
        }
        setContextMenu({
          x: event.clientX,
          y: event.clientY,
          options,
        });
      } else {
        closeContextMenu();
      }
    },
    [selectedObjectId, dispatch, setContextMenu, closeContextMenu, currentFloorId, projectObjects, t]
  );

  return handleContextMenu;
};